export default __webpack_public_path__ + "static/media/Circle_azul.2705a942.png";